var v1="<div id=\"confirmation-new-main\" gnp-common-wrapper-a=\"\"><div class=\"container confirmation-new-main\"><div class=\"col-12 page-header\"><h1>{{:: '_CONFIRMATION.EDIT.TITLE' | translate }}</h1></div><div class=\"col-12 content\"><p ng-show=\"confirmed\">{{:: '_CONFIRMATION.EDIT.SUCCESS' | translate }}</p><p ng-show=\"!confirmed\">{{:: '_CONFIRMATION.EDIT.INVALID' | translate }}</p><button type=\"submit\" ng-click=\"backToDashboard()\" class=\"btn\">{{:: '_CONFIRMATION.EDIT.DASHBOARD' | translate | trustedText}}</button></div></div></div><script>$(document.body).css('min-width', 0)</script>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("web/email-confirmation/edit.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/email-confirmation/edit.jade
// module id = 639
// module chunks = 0